import TagWidget from 'common/components/widget/TagWidget/TagWidget'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'

import {
  addForbiddenWord,
  removeForbiddenWord,
} from '../store/contentSettingsSlice'

const ForbiddenWordsWidget = () => {
  const dispatch = useAppDispatch()

  const forbiddenWords = useAppSelector(
    (state) => state.contentSettings.editedContent.forbiddenWords
  )

  const forbiddenWordsTags = forbiddenWords.map((word) => ({
    label: word?.value,
    value: word?.value,
    isDisabled: word?.isInherited,
  }))
  return (
    <TagWidget
      title="Forbidden words"
      subtitle="Enter the words that should never generate in variants for this region. Entries cannot contain spaces and should be in lower case."
      data-cy="forbidden-words-widget"
      onInputChange={(value) => value.replaceAll(' ', '')}
      placeholder="Forbidden word..."
      tags={forbiddenWordsTags}
      maxLengthPerTag={50}
      onAddTag={(value: string) => {
        dispatch(addForbiddenWord({ value, isInherited: false }))
      }}
      onRemoveTag={(value: string) => {
        dispatch(removeForbiddenWord(value))
      }}
    />
  )
}

export default ForbiddenWordsWidget
